import React from 'react';

function OddsView() {
  return (
    <div className="odds-view">
      <div className="container">
        <h2>Odds Comparison</h2>
        <p>Compare odds across sportsbooks</p>
      </div>
    </div>
  );
}

export default OddsView;
